import { render } from "./CustomButtonFunc.vue?vue&type=template&id=40509aba&scoped=true"
import script from "./CustomButtonFunc.vue?vue&type=script&lang=js"
export * from "./CustomButtonFunc.vue?vue&type=script&lang=js"

import "./CustomButtonFunc.vue?vue&type=style&index=0&id=40509aba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40509aba"]])

export default __exports__